// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertError = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
            <path
                fill="#E60000"
                d="M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12.442 7l-.598.598-1.652 1.652 1.652 1.652.598.598-1.192 1.192-.598-.598L9 10.442l-1.652 1.652-.598.598L5.558 11.5l.598-.598L7.808 9.25 6.156 7.598 5.558 7 6.75 5.808l.598.598L9 8.058l1.652-1.652.598-.598L12.442 7Z"
            />
        </svg>
    );
};

export default React.memo(AlertError);
